import React, { PureComponent, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  number as yupNumber,
} from 'yup';
import PropTypes from 'prop-types';

import { required } from '../shared/forms/validators';
import SelectFormik from '../shared/forms/select/selectFormik.component';
import FormikProvider from '../shared/forms/formikProvider.component';
import Modal from '../shared/modals/modal.component';
import Form from '../shared/forms/form.component';
import { modalDataSelector } from '../shared/modals/modals.selectors';
import { OptionsPropType } from '../shared/propTypes/common';

import {
  hideSetLastClientIdModal,
  saveLastClientId,
} from './store/actions';
import {
  userToEditSelector,
  lastClientOptionsSelector,
} from './store/selectors';

import { SetLastClientIdModal } from './constants';
import { userToEditPropTypes } from './propTypes';

const lastClientSchema = [
  {
    name: 'lastClientId',
    component: SelectFormik,
    meta: { label: 'Last Client', optionsKey: 'lastClientOptions' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true, valueFormatter: x => x },
  },
];

class SetLastClientModal extends PureComponent {
  static propTypes = {
    modalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }),
    userToEdit: userToEditPropTypes,
    lastClientOptions: OptionsPropType,

    hideModal: PropTypes.func.isRequired,
    saveLastClientId: PropTypes.func.isRequired,
  };

  save = async (formData, { setSubmitting, resetForm }) => {
    const {
      hideModal,
      saveLastClientId,
      userToEdit,
    } = this.props;
    const { sso } = userToEdit;

    await saveLastClientId({
      sso,
      lastClientId: formData.lastClientId,
    });

    hideModal();
    setSubmitting(false);
    resetForm();
  };

  renderModal = ({ formik, schema }) => {
    const { hideModal, modalData, lastClientOptions } = this.props;

    const submit = useCallback(() => {
      formik.handleSubmit();
    }, [formik]);

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        title="Set Last Client"
        className="set-last-client-modal"
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submit}
        isLoading={false}
        isSubmitting={formik.isSubmitting}
        isVisible={modalData.show}
      >
        <Form
          formik={formik}
          schema={schema}
          formContext={{
            lastClientOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    return (
      <FormikProvider
        schema={lastClientSchema}
        entityToEdit={{ lastClientId: null }}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  modalData: modalDataSelector(state, SetLastClientIdModal),
  userToEdit: userToEditSelector(state),
  lastClientOptions: lastClientOptionsSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideSetLastClientIdModal,
    saveLastClientId,
  }
)(SetLastClientModal);

